import ReorderStagesDialog from './ReorderStagesDialog';

export default ReorderStagesDialog;
